// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3xH7o","header":"style_header__24F8T","content":"style_content__Nved8"};